import dynamic from 'next/dynamic'
import { type ComponentProps } from 'react'
import { Skeleton } from '@shipt/design-system-loading'

const AdShowcaseSkeleton = () => <Skeleton height={350} />

const DynamicAdShowcase = dynamic(
  () =>
    import('@/features/cms/components/CMS/components/Shelves/AdShowcase').then(
      (mod) => mod.AdShowcase,
    ),
  { loading: AdShowcaseSkeleton },
)
const DynamicAdVideoShowcase = dynamic(
  () =>
    import('@/features/cms/components/CMS/components/Shelves/AdVideoShowcase').then(
      (mod) => mod.AdVideoShowcase,
    ),
  { loading: AdShowcaseSkeleton },
)

type Props =
  | ComponentProps<typeof DynamicAdShowcase>
  | ComponentProps<typeof DynamicAdVideoShowcase>

export const SearchAdShowcaseUnit = (props: Props) => {
  if (props.content_type_id === 'ad_video_showcase') {
    return <DynamicAdVideoShowcase {...props} />
  }
  return <DynamicAdShowcase {...props} />
}
